import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiOrderProgressList, apiOrderProgressView } from 'Services/UserService'

export const getData = createAsyncThunk('user/orderProgress/getData', async datas => {
    const { data } = await apiOrderProgressList(datas)
    return data
})

export const getView = createAsyncThunk('user/orderProgress/getView', async id => {
    const { data } = await apiOrderProgressView(id)
    return data
})

export const orderProgressSlice = createSlice({
    name: 'user/orderProgress',
    initialState: {
        loading: true,
        view: null,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = null
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData } = orderProgressSlice.actions

export default orderProgressSlice.reducer
